const LINKEDIN_HOST = 'linkedin.com'
const PROFILE_SEGMENT = 'in'
const MIN_SLUG_LENGTH = 3

export function normalizeLinkedInProfileUrl(
    value?: string | null,
): string | null {
    if (!value) {
        return null
    }

    const trimmed = value.trim()
    if (!trimmed) {
        return null
    }

    const lowerCased = trimmed.toLowerCase()
    const url = toLinkedInUrl(lowerCased)
    if (!url) {
        return null
    }

    const hostname = url.hostname.toLowerCase()
    if (hostname !== LINKEDIN_HOST && !hostname.endsWith(`.${LINKEDIN_HOST}`)) {
        return null
    }

    const pathname = url.pathname.replace(/\/+/g, '/')
    if (!pathname.startsWith(`/${PROFILE_SEGMENT}/`)) {
        return null
    }

    const segments = pathname.split('/').filter(Boolean)
    if (segments.length < 2 || segments[0] !== PROFILE_SEGMENT) {
        return null
    }

    const slug = segments[1]
    if (!slug) {
        return null
    }

    let decodedSlug: string
    try {
        decodedSlug = decodeURIComponent(slug)
    } catch {
        return null
    }

    const normalizedSlug = decodedSlug.trim().toLowerCase()
    if (normalizedSlug.length < MIN_SLUG_LENGTH || /\s/.test(normalizedSlug)) {
        return null
    }

    return `https://www.linkedin.com/${PROFILE_SEGMENT}/${normalizedSlug}`
}

function toLinkedInUrl(value: string): URL | null {
    try {
        return new URL(value)
    } catch {
        // fall through
    }

    if (!value.includes(LINKEDIN_HOST)) {
        return null
    }

    const prefixed = value.replace(/^\/+/, '')
    try {
        return new URL(`https://${prefixed}`)
    } catch {
        return null
    }
}
